import { useState } from "react";
import Grid from "@mui/material/Grid";
import ModelAutoComplete from "../../actprep-ui/components/ModelAutoComplete";
import { apiUrls } from "../../actprep-ui/utils/urls";
import { useGet } from "../../actprep-ui/hooks/api";
import { useEffect } from "react";
import ProgramWeekNavTree, {
  generateProgramWeekNavItems,
} from "../ProgramWeekNavTree/ProgramWeekNavTree";
import ProgramWeekForm from "../ProgramWeekForm";

export default function SingleProgramWeekNavTree({ onProgramDaySelect }) {
  const [programWeekOption, setProgramWeek] = useState(null);
  const [action, setAction] = useState(null);

  const { data: programWeekData, refetch } = useGet(
    apiUrls.admin.programWeeks(),
    {
      params: {
        search_params: {
          uuid: programWeekOption?.uuid,
        },
        keep_related: true,
        include_curriculum_tree: true,
      },
      enabled: !!programWeekOption?.uuid,
    }
  );
  const [navItems, setNavItems] = useState([]);

  const programWeek = programWeekData?.data[0];

  useEffect(() => {
    if (programWeek) {
      setNavItems(generateProgramWeekNavItems([programWeek]));
    } else {
      setNavItems([]);
    }
  }, [programWeekData, programWeek]);

  useEffect(() => {
    if (!action) {
      return;
    }
    if (action === "reload") {
      refetch();
    }
    setAction(null);
  }, [action, refetch]);

  return (
    <>
      <Grid size={12} mb={1}>
        <ModelAutoComplete
          modelName={"ProgramWeek"}
          label={"Program Week"}
          value={programWeekOption}
          setValue={setProgramWeek}
          allowCreation
          CreationForm={(props) => <ProgramWeekForm {...props} />}
        />
      </Grid>
      <Grid size={12}>
        <ProgramWeekNavTree
          navItems={navItems}
          setAction={setAction}
          setProgramWeek={(programWeek) =>
            setProgramWeek({
              uuid: programWeek?.uuid,
              label: programWeek?.title,
            })
          }
          onProgramDaySelect={onProgramDaySelect}
        />
      </Grid>
    </>
  );
}
